import { getStencilWeek } from "../services/stencilWeekService";
import { getStencil } from "../services/stencilService";

/**
 * Series of utility functions used for stencilWeeks
 */


/**
 * Get all the stencil_week rows that this stencil is part of
 * AND that still need either tracing or carving.
 * 
 * We look at Week 1, 2, and 3 — and check if that stencil was picked (isSelectedWeek1 = 1 etc.)
 * Then we check: if that week's tracing or carving is NOT done (status < 2), we keep it.
 */
export async function getAllIncomplete(stencil) {
  const result = [];

  for (let i = 1; i <= 3; i++) {
    // Check if this stencil is part of Week i
    if (stencil[`isSelectedWeek${i}`] === 1) {
      try {
        // Ask the backend for the stencil_week row for this week
        const res = await getStencilWeek(i, stencil.id);
        const sw = res.stencil_week;

        // Keep this one if tracing or carving is not yet finished (status < 2)
        if (sw && (sw.traced < 2 || sw.carved < 2)) {
          result.push(sw);
        }
      } catch (err) {
        console.error(`Failed to load stencil_week ${i}:`, err);
      }
    }
  }

  return result;
}


/**
 * Finds the earliest week that this stencil is available for a specified step
 * @param {Stencil} stencil
 * @param {Step that this stencil is being checked for} step
 */
export async function getEarliestWeek(stencil, s) {
  // converts the integer into a string representation of the step:
  const convertToString = (num) => {
    switch (Number(num)) {
      case 2:
        return "traced";
      case 3:
        return "carved";
      default:
        return null;
    }
  };

  const step = convertToString(s);

  // not checking for carving or tracing
  if (!step) return 0;

  const string = "isSelectedWeek";
  // check all isSelectedWeek values for this stencil
  for (var i = 1; i < 4; ++i) {
    // stencil is selected for this week, check the status
    if (stencil[`${string}${i}`] == 1) {
      try {
        const res = await getStencilWeek(i, stencil.id);
        // check if the stencil is in progress or not
        if (res.stencil_week[step] < 2) return res.stencil_week.week_num;
      } catch (error) {
        console.error("Error finding week statuses:", error);
        alert(
          "Failed to find week statuses for this stencil, please try again."
        );
      }
    }
  }
  return 0;
}

/**
 * Takes the step status and represents it with a string.
 * @param {Numerical value representing the step} value
 * @returns String representation of what the step status means
 */
export function getStepStatus(value) {
  switch (Number(value)) {
    case 0:
      return "not-started";
    case 1:
      return "in-progress";
    case 2:
      return "completed";
    case 3:
      return "confirmed";
    default:
      return null;
  }
}

/**
 * Takes the step status and represents it with a string of a color.
 * @param {Numerical value representing the step status} value
 * @returns String of a color to be used in style formatting
 */
export function getStepStatusColor(value) {
  switch (Number(value)) {
    case 1:
      return "#F5CC00";
    case 2:
      return "blue";
    case 3:
      return "green";
    default:
      return "gray";
  }
}
